var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57064 1.7464C2.62362 1.69342 2.65012 1.66693 2.67346 1.64548C3.24732 1.11817 4.12941 1.11817 4.70327 1.64548C4.72661 1.66693 4.7531 1.69342 4.80609 1.7464L5.89974 2.84005C6.50127 3.44159 6.67332 4.35002 6.33339 5.12986C5.99346 5.90969 6.1655 6.81812 6.76704 7.41966L8.56464 9.21727C9.16618 9.81881 10.0746 9.99085 10.8544 9.65092C11.6343 9.31099 12.5427 9.48303 13.1443 10.0846L14.2379 11.1782C14.2909 11.2312 14.3174 11.2577 14.3388 11.281C14.8661 11.8549 14.8661 12.737 14.3388 13.3108C14.3174 13.3342 14.2909 13.3607 14.2379 13.4137L13.5731 14.0784C13.0318 14.6198 12.2514 14.847 11.5041 14.6809C6.41186 13.5493 2.43496 9.57245 1.30336 4.48025C1.13729 3.7329 1.36454 2.95251 1.90588 2.41116L2.57064 1.7464Z",
    stroke: "#919DA9",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.a69fab3250cca1eb9ee27af7e24c8a43.svg";
export { ForwardRef as ReactComponent };